import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export const UserDetailsSkeleton = () => {
  return (
    <Stack spacing={3}>
      {/* 2 cards */}
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
        {[1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              flex: 1,
              borderRadius: '24px',
              p: 3,
              background: 'rgba(255,255,255,0.08)',
            }}
          >
            {[1, 2, 3].map((j) => (
              <Stack
                key={j}
                direction='row'
                spacing={2}
                alignItems='center'
                sx={{ mb: 2 }}
              >
                <Skeleton variant='circular' width={40} height={40} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton width='40%' height={20} />
                  <Skeleton width='70%' height={18} />
                </Box>
              </Stack>
            ))}
          </Box>
        ))}
      </Stack>

      {/* About */}
      <Box sx={{ borderRadius: '24px', p: 3 }}>
        <Skeleton width={120} height={28} />
        <Skeleton width='100%' height={20} />
        <Skeleton width='80%' height={20} />
      </Box>

      {/* Categories */}
      <Box sx={{ borderRadius: '24px', p: 3 }}>
        <Skeleton width={160} height={28} />
        <Skeleton width={140} height={36} />
      </Box>
    </Stack>
  );
}
